import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
} from 'recharts';

// Constants for colors
const CLASS_COLORS = {
  class_0: '#3f83f880',
  class_1: '#9243a0',
};

// Available trend ranges
const TREND_RANGES = ['day', 'month', 'year'];

// Helper to format timestamp for X axis
const formatTimestamp = (ts, range) => {
  if (ts === null || ts === undefined || ts === '') return 'N/A';
  return String(ts);
};

function PredictionTrends({
  predictionTrends,
  loadingTrends,
  trendRange,
  setTrendRange,
}) {
  // Map formatted timestamps for chart
  const formattedData = predictionTrends.map((item) => ({
    ...item,
    timestamp: formatTimestamp(item.timestamp),
  }));

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      {/* Header and range buttons */}
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        flexWrap='wrap'
        mb={2}
      >
        <Typography variant='h6'>Prediction Trends</Typography>
        <Box display='flex' gap={1} mt={{ xs: 1, md: 0 }}>
          {TREND_RANGES.map((range) => (
            <Tooltip key={range} title={`View predictions by ${range}`} arrow>
              <Button
                size='small'
                variant={trendRange === range ? 'contained' : 'outlined'}
                onClick={() => setTrendRange(range)}
              >
                {range.charAt(0).toUpperCase() + range.slice(1)}
              </Button>
            </Tooltip>
          ))}
        </Box>
      </Box>

      {/* Legend */}
      <Box display='flex' flexWrap='wrap' mb={2} gap={3}>
        {Object.entries(CLASS_COLORS).map(([cls, color]) => (
          <Box key={cls} display='flex' alignItems='center' gap={1}>
            <Box
              sx={{
                width: 14,
                height: 14,
                backgroundColor: color,
                borderRadius: '2px',
              }}
            />
            <Typography variant='body2'>
              {cls.replace('_', ' ').toUpperCase()}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Chart or loader */}
      <Box>
        {loadingTrends ? (
          <Box display='flex' justifyContent='center' p={5}>
            <CircularProgress />
          </Box>
        ) : formattedData?.length > 0 ? (
          <ResponsiveContainer width='100%' height={300}>
            <BarChart
              data={formattedData}
              margin={{ top: 10, right: 30, left: 50, bottom: 50 }}
            >
              <CartesianGrid strokeDasharray='3 3' />
              <XAxis
                dataKey='timestamp'
                label={{
                  value:
                    trendRange.charAt(0).toUpperCase() + trendRange.slice(1),
                  position: 'bottom',
                  offset: 20,
                }}
              />
              <YAxis
                width={60}
                label={{
                  value: 'Number of Predictions',
                  angle: -90,
                  position: 'outsideLeft',
                  dx: -50,
                }}
              />
              <RechartsTooltip />
              <Bar dataKey='class_0' stackId='a' fill={CLASS_COLORS.class_0} />
              <Bar dataKey='class_1' stackId='a' fill={CLASS_COLORS.class_1} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Typography>No Data To Display</Typography>
        )}
      </Box>
    </Paper>
  );
}

export default PredictionTrends;
